import Twitter from "./twitter.vue";

export default Twitter;
